import { useFragment } from '@apollo/client/react';
import { DocumentType, FileSystemDocumentFileStatus } from 'shared/domains/apollo/generated/types';
import { MalwareScanInformationFragmentDoc } from './MalwareScanInformation.gql';
export function useMalwareScanFragment(from) {
    const { data, complete } = useFragment({
        from,
        fragment: MalwareScanInformationFragmentDoc,
    });
    const { files, type } = data || {};
    const [file] = files || [];
    const { status } = file || {};
    const isUploaded = type === DocumentType.Uploaded;
    // A scan is complete if the document is NOT uploaded OR if the status is Available.
    const scanComplete = !isUploaded || (status && status === FileSystemDocumentFileStatus.Available);
    return {
        done: complete && scanComplete,
        status,
    };
}
